import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {TabViewModule} from 'primeng/tabview';
import {FileUploadModule} from 'primeng/primeng';
import {InputTextareaModule} from 'primeng/primeng';
import {InputTextModule} from 'primeng/primeng';
import {DropdownModule} from 'primeng/primeng';
import {DialogModule} from 'primeng/primeng';
import {ButtonModule} from 'primeng/primeng';
import {TableModule} from 'primeng/table';
import {TooltipModule} from 'primeng/primeng';

import {KeyFilterModule} from 'primeng/keyfilter';

import {CodemirrorModule} from '@nomadreservations/ngx-codemirror';

import {JsonSchemaFormModule, Bootstrap3FrameworkModule} from 'angular2-json-schema-form';

import {datasRouting} from './datas.routing'

import {DataListComponent} from './data-list.component';
import {DataFormComponent} from './data-form.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TabViewModule,
        FileUploadModule,
        InputTextareaModule,
        InputTextModule,
        DropdownModule,
        DialogModule,
        ButtonModule,
        TableModule,
        TooltipModule,
        KeyFilterModule,
        CodemirrorModule,
        Bootstrap3FrameworkModule,
        JsonSchemaFormModule.forRoot(Bootstrap3FrameworkModule),
        datasRouting
    ],
    declarations: [
        DataListComponent,
        DataFormComponent
    ]
})
export class DatasModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/datas/datas.module.ts